import { cached } from '@porotutu/react'
import { listQueryOf } from '@porotutu/react/paging'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { permittedRoute, signedInRoute } from '@/router/root'
import { CRM_POINT_TRANSACTION_SORTABLE, POINT_TRANSACTION_TYPES } from '../vocabulary'
import { pointTransactionQuery, pointTransactionsQuery } from './queries'

const pointTransactionSearch = (raw: Record<string, unknown>) =>
  listQueryOf(raw, CRM_POINT_TRANSACTION_SORTABLE, [], ['voucher_id', 'campaign_id'], {
    transaction_type: POINT_TRANSACTION_TYPES,
  })

export const pointTransactionsRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('point_transactions'),
  path: '/point-transactions',
  validateSearch: pointTransactionSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.query(cached(pointTransactionsQuery(deps))),
  component: lazyRouteComponent(() => import('./pages'), 'PointTransactionsPage'),
})

export const pointTransactionRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('point_transactions'),
  path: '/point-transactions/$id',
  validateSearch: pointTransactionSearch,
  loader: ({ context, params }) =>
    context.queryClient.query(cached(pointTransactionQuery(params.id))),
  component: lazyRouteComponent(() => import('./pages'), 'PointTransactionPage'),
})

export const pointTransactionRoutes = [pointTransactionsRoute, pointTransactionRoute]
